/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{_ as o}from"../../../../../../../chunks/tslib.es6.js";import{UniformGroup as s,uniform as r}from"../../GraphShaderModule.js";import{Float as t}from"../../graph/glsl.js";class e extends s{}o([r(t)],e.prototype,"activeReasons",void 0),o([r(t)],e.prototype,"highlightAll",void 0);export{e as ShaderHighlight};
